export const HEADER_TEXT_HEIGHT = 48;
export const ROW_HEIGHT = 54; // shift with boreder is 50px + 4px margin bottom
export const FIRST_ROW_HEIGHT = 63; // first row has same dimensions as row so 54px + 8px margin top + 1px border top
export const UNASSIGNED_SUMMARY_HEIGHT = 30;
export const SUMMARY_ROW_HEIGHT = 90;
export const COLUMNS_COUNT_WITH_NAME = 8;

export const EVENT_BOX_HEIGHT = 50;
export const EVENT_TEXT_LINE_HEIGHT = 14;
export const BOX_VERTICAL_PADDING = 4;
export const BOX_BOTTOM_SPACING = 4;
export const FIRST_ROW_OFFSET = 9; //8px margin top + 1px border top
export const LAST_ROW_OFFSET = 4;

export const UNASSIGNED = 'unassigned';
export const AVAILABLE = 'available';
